module.exports = __webpack_public_path__ + "img/menu-hair-9.fb299443.jpg";